import React from 'react';
import { CustomFieldType, CustomFieldUtil } from '../../../../../../types/custom_field';
import InnerFilterContent, { FilterInnerContentProps } from '../../../common/DropdownContent/DynamicFilterInnerContent';

export function CustomFieldTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<CustomFieldType>) {
  return (
    <InnerFilterContent
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(filterProps.customFieldType || [])]}
      text={item => CustomFieldUtil.customFieldTypeToString(item as CustomFieldType)}
      onRemove={i => {
        filterProps.customFieldType?.delete(i);
        if (!filterProps.customFieldType?.size) filterProps.customFieldType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
